import { ChangeEvent, useCallback, useState } from 'react';

import { Search } from '@mui/icons-material';
import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import { debounce } from 'src/utils/general';

type WalletFiltersProps = {
  title: string;
  searchEntityName: 'wallet' | 'fund';
  onSearch: (value: string) => void;
  onOrderBy: (value: string) => void;
  orderBy: string;
  useCriticalityFilters?: boolean;
};

export const Filters = ({
  title,
  searchEntityName,
  onSearch,
  onOrderBy,
  orderBy,
  useCriticalityFilters = true,
}: WalletFiltersProps) => {
  const [searchName, setSearchName] = useState('');

  const debouncedSetSearch = useCallback(
    debounce((value: string) => {
      onSearch(value);
    }, 500),
    [],
  );

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchName(value);
    debouncedSetSearch(value);
  };

  const handleOrderBy = (e: SelectChangeEvent<string>) => {
    e.preventDefault();
    const value = e.target.value;
    onOrderBy(value);
  };

  return (
    <Box py={2} px={4} display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6">{title}</Typography>
      <form>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          gap={2}>
          <FormControl>
            <TextField
              variant="outlined"
              label="Busca"
              size="small"
              placeholder={
                searchEntityName === 'wallet'
                  ? 'Digite o nome da sua carteira'
                  : searchEntityName === 'fund'
                    ? 'Digite o nome do fundo'
                    : ''
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
              sx={{
                backgroundColor: 'white',
              }}
            />
          </FormControl>
          <FormControl size="small" variant="outlined" sx={{ minWidth: 140 }}>
            <InputLabel id="order-label">Ordenação</InputLabel>
            <Select
              labelId="order-label"
              label="Ordenação"
              value={orderBy}
              onChange={(e) => handleOrderBy(e)}
              sx={{
                backgroundColor: 'white',
              }}>
              <MenuItem value="name:asc">Nome A-Z</MenuItem>
              <MenuItem value="name:desc">Nome Z-A</MenuItem>
              {useCriticalityFilters && (
                <MenuItem value="criticality:asc">Menos Crítico</MenuItem>
              )}
              {useCriticalityFilters && (
                <MenuItem value="criticality:desc">Mais Crítico</MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>
      </form>
    </Box>
  );
};
